import { initializeApp } from "firebase/app";
import {
  connectFirestoreEmulator,
  initializeFirestore,
  memoryLocalCache,
  persistentLocalCache,
} from "firebase/firestore";
import { connectAuthEmulator, getAuth } from "firebase/auth";
import { connectStorageEmulator, getStorage } from "firebase/storage";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
const useEmulators = process.env.REACT_APP_USE_FIREBASE_EMULATORS === "true";

// Exposed so other modules can reach the initialized app without re-initializing it.
export { app, firebaseConfig };

export const db = initializeFirestore(app, {
  localCache: useEmulators ? memoryLocalCache() : persistentLocalCache(),
  // Firestore's default WebChannel streaming transport is blocked/buffered on
  // some mobile networks and proxies (a common Android-only failure: reads hang
  // forever while iOS/desktop work fine). Auto-detect can itself hang on the
  // initial WebChannel attempt before falling back, so force long-polling — it
  // is slightly less efficient but connects reliably everywhere.
  experimentalForceLongPolling: true,
});
export const storage = getStorage(app);

if (useEmulators && typeof window !== "undefined") {
  const w = window;
  if (!w.__TALLYPOT_FIREBASE_EMULATORS_CONNECTED__) {
    w.__TALLYPOT_FIREBASE_EMULATORS_CONNECTED__ = true;
    const auth = getAuth(app);
    connectAuthEmulator(
      auth,
      `http://${process.env.REACT_APP_FIREBASE_AUTH_EMULATOR_HOST || "127.0.0.1"}:${process.env.REACT_APP_FIREBASE_AUTH_EMULATOR_PORT || "9099"}`,
      { disableWarnings: true }
    );
    connectFirestoreEmulator(
      db,
      process.env.REACT_APP_FIRESTORE_EMULATOR_HOST || "127.0.0.1",
      Number(process.env.REACT_APP_FIRESTORE_EMULATOR_PORT || 8080)
    );
    connectStorageEmulator(
      storage,
      process.env.REACT_APP_FIREBASE_STORAGE_EMULATOR_HOST || "127.0.0.1",
      Number(process.env.REACT_APP_FIREBASE_STORAGE_EMULATOR_PORT || 9199)
    );
    // Callables (deleteGroup, ...) go to the Functions emulator when it runs.
    connectFunctionsEmulator(
      getFunctions(app),
      process.env.REACT_APP_FUNCTIONS_EMULATOR_HOST || "127.0.0.1",
      Number(process.env.REACT_APP_FUNCTIONS_EMULATOR_PORT || 5001)
    );
  }
}
